import { render, staticRenderFns } from "./GoPagesV2List.vue?vue&type=template&id=21811b16&scoped=true"
import script from "./GoPagesV2List.vue?vue&type=script&lang=js"
export * from "./GoPagesV2List.vue?vue&type=script&lang=js"
import style0 from "./GoPagesV2List.vue?vue&type=style&index=0&id=21811b16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21811b16",
  null
  
)

export default component.exports